<mg-table [collectionComponent]="this" matSort stickyHeaders>

	<ng-container matColumnDef="oldid">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Nummer</th>
        <td mat-cell *matCellDef="let row"> {{row.oldID}} </td>
    </ng-container>

	<ng-container matColumnDef="exactNr">
        <th mat-header-cell *matHeaderCellDef mat-sort-header [pd-size-4]> Exact</th>
        <td mat-cell *matCellDef="let row"> {{row.exactNr}} </td>
    </ng-container>

    <ng-container matColumnDef="centixId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header [pd-size-4]> Centix</th>
        <td mat-cell *matCellDef="let row"> {{row.centixId}} </td>
    </ng-container>

    <ng-container matColumnDef="naam1">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Naam </th>
        <td mat-cell *matCellDef="let row"> {{row.naam1}} </td>
    </ng-container>

	<ng-container matColumnDef="naam2">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> T.a.v. </th>
        <td mat-cell *matCellDef="let row"> {{row.naam2}} </td>
    </ng-container>

	<ng-container matColumnDef="tel1">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Telefoon </th>
        <td mat-cell *matCellDef="let row"> {{row.tel1}} </td>
    </ng-container>

	<ng-container matColumnDef="tel2">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Telefoon2 </th>
        <td mat-cell *matCellDef="let row"> {{row.tel2}} </td>
    </ng-container>

	<ng-container matColumnDef="eMail">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
        <td mat-cell *matCellDef="let row"> {{row.eMail}} </td>
    </ng-container>

	<ng-container matColumnDef="postPlaats">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Plaats </th>
        <td mat-cell *matCellDef="let row"> {{row.postPlaats}} </td>
    </ng-container>

    <ng-container matColumnDef="verzendPlaats">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Verzenden </th>
        <td mat-cell *matCellDef="let row"> {{row.verzendPlaats}} </td>
    </ng-container>

    <ng-container matColumnDef="isRelatie">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Relatie </th>
        <td mat-cell *matCellDef="let row"> <mat-icon *ngIf="row.isRelatie">done</mat-icon></td>
    </ng-container>
    
    <ng-container matColumnDef="isLeverancier">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Leverancier </th>
        <td mat-cell *matCellDef="let row"> <mat-icon *ngIf="row.isLeverancier">done</mat-icon></td>
    </ng-container>

    <ng-container matColumnDef="isProspect">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Prospect </th>
        <td mat-cell *matCellDef="let row"> <mat-icon *ngIf="row.isProspect">done</mat-icon></td>
    </ng-container>
    
</mg-table>
